module.exports = __webpack_public_path__ + "img/Nothing For Juice.b0069787.jpg";